import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles.tokens.css';
import './components/ui/ui.css';
import './styles.gamification.css';
import './styles.enterprise.css';
import './index.css';
import './styles.portalV2.css';
import App from './App';
import { applyISTLocaleDefaults } from './utils/istLocale';

applyISTLocaleDefaults();

// Cleanup stale service worker registrations so the browser stops requesting /sw.js.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .catch(() => undefined);
}

// When react-snap pre-renders a route at build time, the resulting index.html for
// that route already contains rendered DOM. In that case we hydrate the existing
// markup instead of replacing it — otherwise React would tear down the SSR output
// during initial render, causing a layout flash.
const rootElement = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
